import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/app'
import RootReducer from './reducers/rootreducer'
import { createStore, applyMiddleware, compose } from 'redux'
import { Provider } from 'react-redux'
import thunk from 'redux-thunk'
import * as serviceWorker from './serviceWorker'
import { getHostAdapter } from './actioncreators/hostAdapter'
import { setHost } from './actioncreators/actioncreators'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const store = createStore(
  RootReducer,
  composeEnhancers(applyMiddleware(thunk))
)

const host = getHostAdapter().getHost()
store.dispatch(setHost(host))

const render = () => {
  ReactDOM.render(
    <Provider store={store}>
      <App queryString={window.location.search} host={host} />
    </Provider>,
    document.getElementById('root')
  )
}

store.subscribe(render)
render()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
